define.alias("ember-power-select/components/power-select", "calendar/components/power-select");